import Lottie from 'lottie-react';

import './GeneralLottie.scss';

const GeneralLottie = ({
  animationData,
  backgroundColor = 'var(--trashie-ui-crisp-white)',
}) => {
  if (!animationData) {
    return null;
  }

  return (
    <div className="GeneralLottie" style={{ backgroundColor }}>
      <Lottie
        animationData={animationData}
        loop
        autoplay
        style={{ aspectRatio: '1', height: '100%' }}
      />
    </div>
  );
};

export default GeneralLottie;
